import SettingsTabBase from "./SettingsTabBase.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { cellAvatarTooltipConfig, getOriginalRecord } from "../../../other/utils/utils.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { assignViewsState, callOnLoadOnColumns } from "../../../other/utils/otherUtils.jsx";
import { INCENTIVE_PERMISSION_KEYS } from "@/other/constants/IncentiveKeys.jsx";

const VIEW_GRID_DATA = [
  { id: INCENTIVE_PERMISSION_KEYS.INCENTIVE_VIEW, label: 'Incentives', value: null },
  { id: INCENTIVE_PERMISSION_KEYS.PENDING_POINTS_VIEW, label: 'Pending Points', value: null },
  { id: INCENTIVE_PERMISSION_KEYS.APPROVED_POINTS_VIEW, label: 'Approved Points', value: null },
  { id: INCENTIVE_PERMISSION_KEYS.DENIED_POINTS_VIEW, label: 'Denied Points', value: null },
  { id: INCENTIVE_PERMISSION_KEYS.AWARDED_POINTS_VIEW, label: 'Awarded Points', value: null },
];

const MANAGE_GRID_DATA = [
  { id: INCENTIVE_PERMISSION_KEYS.INCENTIVE_MANAGERS, label: 'Can manage Incentives', value: [] },
  { id: INCENTIVE_PERMISSION_KEYS.POINT_APPROVERS, label: 'Can approve or deny points', value: [] },
  { id: INCENTIVE_PERMISSION_KEYS.POINT_AWARDERS, label: 'Can award approved points', value: [] },
  { id: INCENTIVE_PERMISSION_KEYS.POINT_ARCHIVERS, label: 'Can archive points', value: [] },
  { id: INCENTIVE_PERMISSION_KEYS.POINT_DELETERS, label: 'Can delete points', value: [] },
];

const GRID_COMMON_CONFIG = {
  type: WIDGET_KEYS.swivuPreferenceStyleGrid,
  cls: "h-full",
  listeners: {
    cellClick: "up.onCellClick",
    dataChange: "up.onSwivuGridDataChange"
  },
  features: {
    sort: false,
    group: false,
    cellMenu: false,
    cellTooltip: cellAvatarTooltipConfig
  }
}

export default class SwivuSettingsIncentivePermissionsTab extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingsIncentivePermissionsTab";
  }

  static get type() {
    return "swivusettingincentivepermissionstab";
  }

  static get configurable() {
    return {
      title: "Incentives Permissions",
      cls: "p-[1em] flex-col gap-[1em]",
      defaults: {
        labelWidth: "7em"
      },
      items: {
        tabs: {
          type: "tabPanel",
          stateId: "swivu-settings-incentive-permissions-tab",
          cls: "[&_.b-tabpanel-body]:px-0 [&_.b-tabpanel-tab]:border-b-[2px] [&_.b-tabpanel-tab.b-active]:!border-b-[var(--clr-primary)]",
          items: {
            viewPermissionsTab: {
              title: "Can View Permissions",
              items: {
                viewPermissionsGrid: {
                  ...GRID_COMMON_CONFIG,
                  stateId: "b-settings-incentive-view-permission-grid-v1",
                  columns: [
                    {
                      id: 'canView',
                      text: 'Can View',
                      field: 'label',
                      editor: false,
                      minWidth: "9em"
                    },
                    {
                      id: 'incentiveRolePermissionColumn',
                      field: 'value',
                      text: "Permission Role",
                      type: WIDGET_KEYS.incentiveRolePermissionColumn
                    },
                  ],
                }
              }
            },
            managePermissionsTab: {
              title: "Can Manage Permissions",
              items: {
                managePermissionsGrid: {
                  ...GRID_COMMON_CONFIG,
                  stateId: "b-settings-incentive-manage-permission-grid-v1",
                  columns: [
                    {
                      id: 'canManage',
                      text: 'Can Manage',
                      field: 'label',
                      editor: false,
                      minWidth: "14em"
                    },
                    {
                      id: 'incentiveUserPermissionColumn',
                      text: "Board Users",
                      type: WIDGET_KEYS.incentiveUserPermissionColumn,
                      field: "value",
                    },
                  ],
                }
              }
            }
          }
        }
      }
    };
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);

    if (otherParams.isFirstShow) {
      const { viewPermissionsGrid, managePermissionsGrid } = this.widgetMap;

      [viewPermissionsGrid, managePermissionsGrid].forEach(grid => {
        callOnLoadOnColumns(grid.columns, context.project);
        assignViewsState([grid], this.stateProvider);
      });
      this.populateGrid();
    }
  }


  onCellClick({ column, record, event }) {
    if(column.id === "incentiveUserPermissionColumn" || column.id === "incentiveRolePermissionColumn") {
       const originalRecord = getOriginalRecord(record);
       this.editorHandler.openEditor(EDITOR_KEYS.entityTagEditor, null, {
        entityRecord: originalRecord,
        event,
        column
      }, { by: "recordType", useExisting: true });
    }
  }

  populateGrid() {
    const { viewPermissionsGrid, managePermissionsGrid } = this.widgetMap;
    const incentiveBoardPreferences = this.project.incentiveBoardPreferencesStore.first;

    const viewGridData = VIEW_GRID_DATA.map(item => ({
      ...item,
      value: incentiveBoardPreferences[item.id]
    }));

    const manageGridData = MANAGE_GRID_DATA.map(item => ({
      ...item,
      value: incentiveBoardPreferences[item.id] || []
    }));

    viewPermissionsGrid.store.data = viewGridData;
    managePermissionsGrid.store.data = manageGridData;
  }

  onSwivuGridDataChange({ record, action }) {
    /* Update the preference value in the store */
    if (action === "update") {
      const incentiveBoardPreferences = this.project.incentiveBoardPreferencesStore.first;
      incentiveBoardPreferences[record.id] = record.value;
    }
  }
}
SwivuSettingsIncentivePermissionsTab.initClass();
